import { parseToRgb } from 'polished'
import { RgbaColor, RgbColor } from 'polished/lib/types/color'

function composite(fg: RgbaColor, bg: RgbaColor) {
  const alpha = fg.alpha + bg.alpha * (1 - fg.alpha)

  return {
    red: Math.round(
      (fg.red * fg.alpha + bg.red * bg.alpha * (1 - fg.alpha)) / alpha
    ),
    green: Math.round(
      (fg.green * fg.alpha + bg.green * bg.alpha * (1 - fg.alpha)) / alpha
    ),
    blue: Math.round(
      (fg.blue * fg.alpha + bg.blue * bg.alpha * (1 - fg.alpha)) / alpha
    ),
    alpha,
  }
}

const normalizeColor = (color: RgbColor | RgbaColor) => {
  if ('alpha' in color) {
    return color
  }

  return { ...color, alpha: 1 }
}

export const overlayColors = (bg: string, fg: string) => {
  const fgC = normalizeColor(parseToRgb(fg))
  const bgC = normalizeColor(parseToRgb(bg))

  const result = composite(fgC, bgC)

  return `rgba(${result.red},${result.green},${
    result.blue
  },${result.alpha.toFixed(3)})`
}
